module.exports = __webpack_public_path__ + "static/media/illustration-element-05.a13a0843.svg";